import type { SanitizedFeedSectionArticle, Section } from "@app/types/Cue";
import { FeedTag } from "@pages/Keyword/utils/types";
import { TagType } from "@pages/Section/types";

import { FeedSectionItems } from "./types";

/**
 * Helper function to sanitize the feed section items from BT Backend API.
 * @param articles - The articles to sanitize.
 * @returns {SanitizedFeedSectionArticle[]} - The articles of type SanitizedFeedSectionArticle.
 */
export const sanitizeFeedSectionItems = (
  articles: FeedSectionItems[]
): SanitizedFeedSectionArticle[] => {
  return (
    articles?.map(({ articleData }) => {
      const tags: FeedTag[] =
        articleData.tags?.map((tag) => {
          return {
            id: tag.id || "",
            name: tag.name || "",
            type: tag.type || TagType.Keyword,
            urlPath: tag.urlPath || "",
          };
        }) || [];

      const _section: Section[] = articleData.sections.map((section) => {
        return {
          name: section.name || "",
          uniqueName: section.uniqueName || "",
          href: section.urlPath || "",
          parent: {
            name: section.parent?.name || "",
            uniqueName: section.parent?.uniqueName || "",
            directoryName: section.parent?.urlPath || "",
          },
        };
      });

      const _kicker = {
        id: "kicker-" + articleData.id,
        type: "kicker",
        fields: [
          {
            name: "kicker",
            value: articleData.kicker || "",
            annotations: [],
          },
        ],
      };

      const _displaySettings = {
        displayHeadline: "",
        externalURL: "",
        hasUpdatedTimeDisplayed: false,
      };

      const _paywall = {
        contentAccess: "",
        copyright: "",
      };

      const sanitizeFeedSectionItem: SanitizedFeedSectionArticle = {
        id: articleData.id,
        title: articleData.title,
        urlPath: articleData.urlPath,
        created: articleData.publishTime || "",
        updated: articleData.publishTime || "",
        edited: articleData.editedTime || "",
        media: articleData.media || [],
        slug: articleData.urlPath || "",
        kicker: _kicker,
        blurb: articleData.blurb || "",
        sections: _section || [],
        authors: articleData.authors || [],
        tags: tags || [],
        displaySetting: _displaySettings,
        paywall: _paywall,
        relatedContributorProfile: [],
      };

      return sanitizeFeedSectionItem;
    }) || []
  );
};
